import React from 'react';
import { Icon } from '@uhg-abyss/web/ui/Icon';

export const AiIcon = ({ feature = '' }) => {
  const fillColor =
    feature === 'onDemandClaimsReporting' ? '#676666' : '#002677';
  const aiIcon = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_711_946)">
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          fill={`${fillColor}`}
        />
        <path
          d="M13.7583 11.304C10.6458 11.304 8.12498 8.78318 8.12498 5.67068C8.12498 5.57901 8.05415 5.50818 7.96248 5.50818C7.87082 5.50818 7.79998 5.57901 7.79998 5.67068C7.79998 8.78318 5.27915 11.304 2.16665 11.304C2.07498 11.304 2.00415 11.3748 2.00415 11.4665C2.00415 11.5582 2.07498 11.629 2.16665 11.629C5.27915 11.629 7.79998 14.1498 7.79998 17.2623C7.79998 17.354 7.87082 17.4248 7.96248 17.4248C8.05415 17.4248 8.12498 17.354 8.12498 17.2623C8.12498 14.1498 10.6458 11.629 13.7583 11.629C13.85 11.629 13.9208 11.5582 13.9208 11.4665C13.9208 11.3748 13.85 11.304 13.7583 11.304Z"
          fill="white"
        />
        <path
          d="M16.6543 5.54151C15.1251 5.54151 13.8876 4.29985 13.8876 2.77485C13.8876 2.72901 13.8543 2.69568 13.8084 2.69568C13.7626 2.69568 13.7293 2.72901 13.7293 2.77485C13.7293 4.30401 12.4876 5.54151 10.9626 5.54151C10.9168 5.54151 10.8834 5.57485 10.8834 5.62068C10.8834 5.66651 10.9168 5.69985 10.9626 5.69985C12.4918 5.69985 13.7293 6.94151 13.7293 8.46651C13.7293 8.51235 13.7626 8.54568 13.8084 8.54568C13.8543 8.54568 13.8876 8.51235 13.8876 8.46651C13.8876 6.93735 15.1293 5.69985 16.6543 5.69985C16.7001 5.69985 16.7334 5.66651 16.7334 5.62068C16.7334 5.57901 16.7001 5.54151 16.6543 5.54151Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_711_946">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  return (
    <Icon size="20px">
      {aiIcon}
    </Icon>
  );
};
